import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Fathom from 'fathom-client';

const FATHOM_SITE_ID = 'YZSIDMBP';

export const useFathom = () => {
    const location = useLocation();

    useEffect(() => {
        // Initialize Fathom when the app loads
        Fathom.load(FATHOM_SITE_ID, {
            includedDomains: [window.location.hostname],
        });

        // Record a pageview when location changes
        Fathom.trackPageview();

        // Add listener for route changes
        const handleRouteChange = () => {
            Fathom.trackPageview();
        };

        // Listen for route changes
        window.addEventListener('popstate', handleRouteChange);

        return () => {
            window.removeEventListener('popstate', handleRouteChange);
        };
    }, [location]);
};
